export default theme => ({
  secondCoachActions: {
    marginTop: 20,
  },
  secondCoachButton: {
    marginBottom: 20,
  },
});
